// extracted by mini-css-extract-plugin
export default {"table":"styles_table__CHCFl","button":"styles_button__4nXYw","title":"styles_title__dw4YE"};